import { t } from "@lingui/macro";
import { ExchangeRateSource } from "@src/__generated__/graphql";
import { type IOption, Select, type SelectProps } from "@src/components/ui-kit";

type ExchangeRateSourceSelectProps = {
  value: ExchangeRateSource;
  onChange: (value: ExchangeRateSource) => void;
  error: SelectProps["error"];
};
export const ExchangeRateSourceSelect = ({
  value,
  onChange,
  error,
}: ExchangeRateSourceSelectProps) => {
  const EXCHANGE_RATE_OPTIONS: IOption[] = [
    { value: ExchangeRateSource.Workspace, label: t`System exchange rate` },
    { value: ExchangeRateSource.Auto, label: t`ECB exchange rate` },
    { value: ExchangeRateSource.Client, label: t`Client exchange rate` },
    { value: ExchangeRateSource.Custom, label: t`Custom exchange rate` },
    { value: ExchangeRateSource.Budget, label: t`Budget exchange rate` },
  ];

  return (
    <Select
      value={value}
      onChange={onChange}
      error={error}
      options={EXCHANGE_RATE_OPTIONS}
    />
  );
};
